// Central content + media for JAZZY THE GREAT landing page.
// Placeholder images & links — swap freely later.

export const BUSINESS = {
  name: "JAZZY THE GREAT",
  phone: "+ 1 (631) 836 - 9593",
  phoneHref: "tel:+16318369593",
  email: "booking@djyungjazzy.com",
  emailHref: "mailto:booking@djyungjazzy.com",
  instagram: "https://www.instagram.com/_jazzythegreat_/",
  soundcloud: "https://soundcloud.com/djyungjazzy-noulababy",
};

export const HERO_IMG =
  "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400";

export const HERO_VIDEO_HD =
  "https://videos.pexels.com/video-files/16510380/16510380-hd_1920_1080_60fps.mp4";
export const HERO_VIDEO_SD =
  "https://videos.pexels.com/video-files/16510380/16510380-hd_1280_720_60fps.mp4";

export const PORTRAIT_IMG = "/jazzy-portrait.webp";

export const SERVICES = [
  {
    id: "weddings",
    index: "01",
    title: "Weddings",
    tag: "The First Dance",
    copy: "From the aisle to the last song — a seamless, emotional soundtrack curated around your love story.",
    img: "https://images.unsplash.com/photo-1648154164366-d067faecdc51?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    id: "clubs",
    index: "02",
    title: "Club Appearances",
    tag: "Peak Hour",
    copy: "High-energy sets built for the floor. Reading the room, riding the tension, never dropping the vibe.",
    img: "https://images.unsplash.com/photo-1584352604394-c2c6f06e00c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    id: "private",
    index: "03",
    title: "Private Parties",
    tag: "Invitation Only",
    copy: "Intimate, tailored, unforgettable. Your guest list, your genres, your night — elevated.",
    img: "https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    id: "occasions",
    index: "04",
    title: "All Occasions",
    tag: "Anything Else",
    copy: "Corporate galas, birthdays, brand launches, festivals. If it needs a sound, it needs Jazzy.",
    img: "https://images.unsplash.com/photo-1522158637959-30385a09e0da?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "The Sound",
    copy: "Every set is engineered, not shuffled. Transitions you feel before you hear them, a low end that lives in your chest, and a melody that finds you across the room.",
  },
  {
    n: "02",
    title: "The Room",
    copy: "I read energy in real time. A wedding breathes differently than a warehouse. The craft is knowing exactly when to lift, when to hold, and when to let the crowd take over.",
  },
  {
    n: "03",
    title: "The Moment",
    copy: "People forget playlists. They remember how a night made them feel. My job is to build the moment that everyone talks about long after the lights come up.",
  },
];

// Placeholder public SoundCloud profiles — swap with your own tracks/sets.
export const MIXES = [
  {
    title: "Midnight Sessions",
    genre: "House · Afro · Deep",
    url: "https://soundcloud.com/tiesto",
  },
  {
    title: "The Wedding Set",
    genre: "Open Format · Classics",
    url: "https://soundcloud.com/martingarrix",
  },
  {
    title: "Warehouse Vol. IV",
    genre: "Tech House · Peak",
    url: "https://soundcloud.com/davidguetta",
  },
];

// Curated gallery (grayscale → color on hover). Swap with your IG posts.
export const GALLERY = [
  { img: "https://images.unsplash.com/photo-1584352604394-c2c6f06e00c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", span: "col-span-2 row-span-2", cap: "@ Sound Nightclub" },
  { img: "https://images.unsplash.com/photo-1648154164366-d067faecdc51?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", span: "", cap: "The First Dance" },
  { img: "https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", span: "", cap: "Peak Hour" },
  { img: "https://images.unsplash.com/photo-1522158637959-30385a09e0da?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", span: "col-span-2", cap: "Rooftop Sessions" },
  { img: "https://images.unsplash.com/photo-1594623930572-300a3011d9ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", span: "", cap: "Decks Up Close" },
  { img: "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", span: "", cap: "Festival Main Stage" },
];
